import SavedPoiCTAButton from './saved-poi-cta-button';

export default SavedPoiCTAButton;
